import React from 'react';

export default function ConfirmModal({ title, body, onConfirm, onCancel, confirmText = 'ยืนยัน', danger = false }) {
  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <div className="modal-title">{title}</div>
        <div className="modal-body">{body}</div>
        <div className="modal-actions">
          <button className="btn-secondary" onClick={onCancel}>ยกเลิก</button>
          <button
            className="btn-primary"
            style={danger ? { background: '#dc2626', boxShadow: '0 1px 3px rgba(220,38,38,.3)' } : {}}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
